<template>
  <div class="mustSeeSpot">
    <div class="search-container">
      <el-row>
        <el-col :span="16">
          <el-form ref="form" :model="form" label-width="120px">
            <el-row>
              <el-col :span="12">
                <el-form-item prop="venueName" label="场馆名称">
                  <el-input clearable v-model="form.venueName" placeholder="请输入场馆名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="mainDirection" label="主营方向">
                  <el-select v-model="form.mainDirection" style="width:100%">
                    <el-option v-for="item in mainDirectionBox" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="8" style="text-align:right">
          <el-button @click="searchEvent" class="search-button">{{$t('search')}}</el-button>
          <el-button @click="cleanForm" class="clean-button">{{$t('clean')}}</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="table-container">
      <el-table
				:data="tableData"
        :height="tableHeight"
				style="width: 100%"
        border
        @sort-change='sort_post_change'
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange">
				<el-table-column
					type="selection"
          align="center"
          fixed="left"
					width="55">
				</el-table-column>
        <el-table-column
					prop="venueName"
          min-width="168"
          align="center"
					label="场馆名称">
				</el-table-column>
				<el-table-column
					prop="mainDirection"
          align="center"
          min-width="168"
					label="主营方向">
				</el-table-column>
				<el-table-column
					prop="accommodateQty"
          align="center"
          min-width="115"
					label="可容纳人数">
				</el-table-column>
        <el-table-column
					prop="address"
          align="center"
          min-width="168"
					label="场馆地址">
				</el-table-column>
        <el-table-column
					prop="reservationSupport"
          align="center"
          min-width="115"
					label="商家状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.reservationSupport" active-value="Y" inactive-value="N" @change="(value) => updateStatus(value, scope.row.id, scope.$index)"></el-switch>
          </template>
				</el-table-column>
        <el-table-column
					prop="collectCount"
          align="center"
          min-width="115"
					label="操作">
          <template slot-scope="scope">
            <el-button class="default-button" v-if="buttonAuth.includes('baseVenue:edit')" @click="changeAddDialog(true, true, scope.row)">{{$t('edit')}}</el-button>
          </template>
				</el-table-column>
			</el-table>
    </div>
    <div class="page-content">
      <div>
        <el-button style="float:left;" class="default-button" v-if="buttonAuth.includes('baseVenue:add')" @click="changeAddDialog(true)">{{$t('add')}}</el-button>
        <el-button style="float:left;" class="default-button" v-if="buttonAuth.includes('baseVenue:remove')" :disabled="selectedArr.length < 1" @click="openDeleteDialog(selectedArr.map(item => item.id).join(','), 1)">{{$t('delete')}}</el-button>
        <el-button style="float:left;" class="default-button" v-if="buttonAuth.includes('baseVenue:download')" @click="downFile">下载导入模板</el-button>
        <el-upload
          class="upload"
          style="float:left;margin-left:10px"
          :show-file-list="false"
          :with-credentials="true"
          :action="apis.importVenueInfo"
          :httpRequest="uploadHttpDefault"
          name="file"
          :limit="999"
          :data="{isUpdateSupport: false}"
          :on-success="uploadSuccess"
          :on-error="uploadError"
        >
          <el-button class="default-button" v-if="buttonAuth.includes('baseVenue:import')">导入</el-button>
        </el-upload>
      </div>
    <!-- </div>
    <div class="page-container"> -->
      <el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="form.pageNum"
				:page-sizes="[10, 20, 30, 40]"
				:page-size="form.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="form.total">
			</el-pagination>
    </div>
    <!-- 添加/修改弹窗 -->
    <add-dialog ref="addDialog" :Language="Language" :show="addDialog.visible" :isEdit="addDialog.isEdit" @closeDialog="changeAddDialog"></add-dialog>
    <!-- 删除确认弹窗 -->
    <confirm-dialog ref="confirmDialog" :Language="Language" :show="confirmDialog.visible" :type="confirmDialog.type" @sureDialog="sureConfirmDialog" @closeDialog="changeConfirmDialog"></confirm-dialog>
  </div>
</template>
<script>
import IndexClass from './indexClass'
import mixin from '@/mixins/index'
import apis from '@/apis'
import { mapState } from "vuex";
import addDialog from "./dialog/addDialog.vue";
import confirmDialog from '@/components/confirmDialog.vue'
import download from '@/mixins/download'

export default {
  mixins: [mixin, download],
  components: { addDialog, confirmDialog },
  data() {
    return {
      form: new IndexClass('form'), // 实例化一个表单的变量
      tableData: [],
      addDialog: {
        visible: false,
        isEdit: false,
      },
      confirmDialog: {
        visible: false,
        type: 1, //1:删除 9：发布
        data: {},
      },
      mainDirectionBox: [], // 主营方向下拉框
    }
  },
  computed: {
    ...mapState(["Language", "DROPDOWNBOX", "TOKEN", 'venueId']),
  },
  activated() {
    this.$http.get(apis.getMainDirectionList).then((res) => {
      if (res.data.code === 0) {
        this.mainDirectionBox = res.data.rows
      }
    })
  },
  methods: {
    // tabs切换
    tabsClick() {
      this.searchEvent()
    },
    // 表格选中
    handleSelectionChange(arr) {
      this.selectedArr = arr
    },
    // 清空按钮
    cleanForm() {
      this.$refs.form.resetFields()
      this.searchEvent()
    },
    // 查询
    searchData() {
      const formData = { ...this.form }
      this.$http.post(apis.venueInfoList, formData).then((res) => {
        if (res.data.code === 0) {
          this.tableData = res.data.rows
          this.form.total = res.data.total
        }
      })
    },
    // 新增修改
    changeAddDialog(dialogStatus, isEdit = false, data) {
      if (dialogStatus) {
        this.addDialog.isEdit = isEdit;
        if (isEdit) {
          // 调用vuex里面的获取数据的业务，如果要在这里写接口，需要改成Promise
          this.$refs["addDialog"].getDataQuery(data);
        }
      } else {
        this.searchData();
      }
      this.$nextTick(() => {
        this.addDialog.visible = dialogStatus;
      });
    },
    /**
     * @function 改变确认/删除弹窗的状态
     * @param {Boolean} dialogStatus 是否展示当前弹窗
     * @param {Number} type 打开的弹窗类型，1为删除确认
     */
    changeConfirmDialog(dialogStatus, type = 1) {
      this.confirmDialog.type = type
      this.confirmDialog.visible = dialogStatus
      if (!dialogStatus) {
        this.confirmDialog.data.ids = ''
        this.searchEvent()
      }
    },
    /**
     * 删除和发布点击确认
     * id: 对应的id值
     * type 1：删除 9:发布
     */
    /* eslint-disable */
    openDeleteDialog(id, type) {
      this.confirmDialog.type = type
      this.confirmDialog.data.ids = id
      this.changeConfirmDialog(true, type)
    },
    /**
     * @function 当确认弹窗点击确定的时候触发
     */
    sureConfirmDialog() {
      // 如果一个页面有多个弹窗，视情况决定用if语句还是二元表达式对api进行判断
      this.modelDelete()
    },
    /**
     * 删除
     */
    modelDelete() {
      this.$http.delete(`${apis.removeVenueInfo}?ids=${this.confirmDialog.data.ids}`).then((res) => {
        if (res.data.code === 0) {
          this.$refs.confirmDialog.closeDialog()
          this.$message.success("删除成功!")
          this.searchData()
        }
      })
    },
    // 导入
    uploadError(res) {
      console.log(res);
      this.searchEvent()
    },
    uploadSuccess(res) {
      if (res.data.code === 0) {
        this.searchEvent()
      }
    },
    updateStatus(value, id, index) { // 商家状态改变
      this.$http.post(apis.updateVenueReservationSupport, {id: id}).then((res) => {
        if (res.data.code === 0) {
          console.log(res.data)
        } else {
          if (value === 'N') {
            this.tableData[index].reservationSupport = 'Y'
          } else {
            this.tableData[index].reservationSupport = 'N'
          }
        }
      })
    },
    downFile() {
      const mimeMap = {
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8',
        zip: 'application/zip',
        xml: 'application/xml',
      }
      this.$http.get(apis.downloadVenueImportTemplate, {responseType: 'blob'},).then((res) => {
        this.resolveBlob(res, mimeMap.xlsx)
      })
    },
  },
}
</script>
<style lang="less" scoped>
@import "../../../assets/styles/mixin.scoped.less";
</style>
<style lang="less">
@import "../../../assets/styles/mixin.less";
.mustSeeSpot {
  .page-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
  }
}
</style>
